import { iots } from '@code-expert/prelude';
import { CourseId, ExamId, ExerciseId, SemesterId } from '/imports/domain/identity';
import type { User } from '/imports/domain/user';
import { isExamUser } from '/imports/domain/user';
import type { ExamStatus } from './ExamStatus';
import { ExamStatusC } from './ExamStatus';
import { ExamVerification } from './ExamVerification';

export interface Exam {
  readonly _id: ExamId;
  readonly name: string;
  readonly courseId: CourseId;
  readonly semester: SemesterId;
  readonly exerciseId: ExerciseId;
  readonly verification: ExamVerification;
  readonly accessToken: string;
  readonly instructions: string;
  readonly status: ExamStatus;
}

export const ExamC = iots.strict({
  _id: ExamId,
  name: iots.string,
  courseId: CourseId,
  semester: SemesterId,
  exerciseId: ExerciseId,
  verification: ExamVerification,
  accessToken: iots.minLengthString(43),
  instructions: iots.string,
  status: ExamStatusC,
}) satisfies iots.Type<Exam, unknown>;

export const examPublicFields = {
  _id: 1,
  name: 1,
  courseId: 1,
  semester: 1,
  exerciseId: 1,
  instructions: 1,
  status: 1,
} as const;

export type ExamPublicFields = keyof typeof examPublicFields;

export type ExamPublic = Pick<Exam, ExamPublicFields>;

// -------------------------------------------------------------------------------------------------

export const isOpenForReview = (exam: ExamPublic): boolean => exam.status === 'review';

export const hasExamAccess = (examId: ExamId) => (user: User) =>
  !isExamUser(user) || (isExamUser(user) && user.examId === examId);
